import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/types/queryKeys'
import { dashboardApi } from '../api/dashboardApi'

/** Fetches the dashboard summary */
export function useDashboard() {
  return useQuery({
    queryKey: queryKeys.dashboard.summary(),
    queryFn: dashboardApi.getSummary,
    staleTime: 30 * 1000, // Consider fresh for 30 seconds
  })
}
